<div>
  <div class="row">
    <div class="col-sm-8 col-md-7">
      <div style="display: flex">
        <h1 class="aru-title">
          Inspections
          <i
            *ngIf="canExport"
            (click)="downloadSummary()"
            style="font-size: 17px; cursor: pointer"
            class="fa fa-file-text-o"></i>
        </h1>
        <a *ngIf="canAdd" routerLink="/inspection/form/add" class="btn aru btn-primary">Create new</a>
      </div>
    </div>

    <div class="col-sm-4 col-md-5">
      <!-- <inspection-tabs active="flow"></inspection-tabs> -->
      <tabs [hide]="false" [type]="'flow'" #tabs active="flow"></tabs>
    </div>
  </div>

  <div class="search-filter-wrapper">
    <div class="search-bar">
      <app-inspection-filter-cards (searchTermUpdated)="setSearchTerm($event)"></app-inspection-filter-cards>
    </div>
    <!-- Assignee Filter -->
    <app-inspection-assignee-filter
      #assignFilter
      (assigneeChange)="updateAssignees($event)"
      [filteredAssignees]="filteredAssignees"></app-inspection-assignee-filter>
    <!-- Product Type Filter -->
    <app-inspection-product-filter
      [productTypes]="productTypes"
      (productTypesChanged)="filterProductTypes($event)"></app-inspection-product-filter>
  </div>

  <br />

  <div id="headers">
    <div>
      <h6>
        No Date Assigned
        <span
          >({{
            (noDate | searchPipe: { searchTerm: this.search, productTypes: this.productTypes, filteredAssignees })
              ?.length
          }})</span
        >
      </h6>
    </div>

    <div>
      <h6>
        Ready to be Assigned
        <span
          >({{
            (toBeAssigned | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length
          }})</span
        >
      </h6>
    </div>

    <div>
      <h6>
        Assignment Made
        <span
          >({{ (assigned | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length }})</span
        >
      </h6>
    </div>

    <div>
      <h6>
        Due Completion
        <span
          >({{
            (dueCompletion | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length
          }})</span
        >
      </h6>
    </div>

    <div style="display: inline-block">
      <h6 style="display: inline-block; width: 80%">
        Needs Review
        <span
          >({{
            (needsReview | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length
          }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activeNeedsReviewSort === 'HighestScoredFirst'"
            (click)="sortNeedsReviewHighestScoredFirst()"
            >Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeNeedsReviewSort === 'OldestFirst'"
            (click)="sortNeedsReviewOldestFirst()"
            >Oldest inspections first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeNeedsReviewSort === 'NewestFirst'"
            (click)="sortNeedsReviewNewestFirst()"
            >Newest inspections first</a
          >
        </div>
      </div>
    </div>

    <div style="display: inline-block">
      <h6 style="display: inline-block; width: 80%">
        Under Review
        <span
          >({{
            (underReview | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees })?.length
          }})</span
        >
      </h6>
      <div class="dropdown" style="display: inline-block; width: 10%; text-align: right" dropdown>
        <button type="button" class="btn btn-bulk" dropdownToggle>
          <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu right" *dropdownMenu>
          <h6 class="dropdown-header">Please select the sorting order</h6>
          <a
            class="dropdown-item"
            [class.highlighted]="activeUnderReviewSort === 'HighestScoredFirst'"
            (click)="sortUnderReviewHighestScoredFirst()"
            >Highest scored first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeUnderReviewSort === 'OldestFirst'"
            (click)="sortUnderReviewOldestFirst()"
            >Oldest inspections first</a
          >
          <a
            class="dropdown-item"
            [class.highlighted]="activeUnderReviewSort === 'NewestFirst'"
            (click)="sortUnderReviewNewestFirst()"
            >Newest inspections first</a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- No Date Assigned -->
  <div
    *ngIf="
      !(
        isNoDate() &&
        isToBeAssignedData() &&
        isAssignedData() &&
        isDueCompletion() &&
        isNeedsReview() &&
        isUnderReview()
      );
      else noResult
    "
    id="wrapper"
    #wrapper>
    <div>
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="noDate !== null">
            <div
              class="card-inspection"
              *ngFor="
                let inspection of noDate | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                </div>
              </div>

              <div class="card-footer-actions" *ngIf="canEdit">
                <div (click)="addDate($event, inspection)" class="tooltip-container" data-tooltip="Add date">
                  <!-- Default SVG -->
                  <span class="default-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M7 16.875C7 17.4961 7.50391 18 8.125 18H16.375C16.9961 18 17.5 17.4961 17.5 16.875V10.5H7V16.875ZM14.5 12.2812C14.5 12.1266 14.6266 12 14.7812 12H15.7188C15.8734 12 16 12.1266 16 12.2812V13.2188C16 13.3734 15.8734 13.5 15.7188 13.5H14.7812C14.6266 13.5 14.5 13.3734 14.5 13.2188V12.2812ZM14.5 15.2812C14.5 15.1266 14.6266 15 14.7812 15H15.7188C15.8734 15 16 15.1266 16 15.2812V16.2188C16 16.3734 15.8734 16.5 15.7188 16.5H14.7812C14.6266 16.5 14.5 16.3734 14.5 16.2188V15.2812ZM11.5 12.2812C11.5 12.1266 11.6266 12 11.7812 12H12.7188C12.8734 12 13 12.1266 13 12.2812V13.2188C13 13.3734 12.8734 13.5 12.7188 13.5H11.7812C11.6266 13.5 11.5 13.3734 11.5 13.2188V12.2812ZM11.5 15.2812C11.5 15.1266 11.6266 15 11.7812 15H12.7188C12.8734 15 13 15.1266 13 15.2812V16.2188C13 16.3734 12.8734 16.5 12.7188 16.5H11.7812C11.6266 16.5 11.5 16.3734 11.5 16.2188V15.2812ZM8.5 12.2812C8.5 12.1266 8.62656 12 8.78125 12H9.71875C9.87344 12 10 12.1266 10 12.2812V13.2188C10 13.3734 9.87344 13.5 9.71875 13.5H8.78125C8.62656 13.5 8.5 13.3734 8.5 13.2188V12.2812ZM8.5 15.2812C8.5 15.1266 8.62656 15 8.78125 15H9.71875C9.87344 15 10 15.1266 10 15.2812V16.2188C10 16.3734 9.87344 16.5 9.71875 16.5H8.78125C8.62656 16.5 8.5 16.3734 8.5 16.2188V15.2812ZM16.375 7.5H15.25V6.375C15.25 6.16875 15.0813 6 14.875 6H14.125C13.9187 6 13.75 6.16875 13.75 6.375V7.5H10.75V6.375C10.75 6.16875 10.5812 6 10.375 6H9.625C9.41875 6 9.25 6.16875 9.25 6.375V7.5H8.125C7.50391 7.5 7 8.00391 7 8.625V9.75H17.5V8.625C17.5 8.00391 16.9961 7.5 16.375 7.5Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <!-- Hover SVG -->
                  <span class="hover-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M7 16.875C7 17.4961 7.50391 18 8.125 18H16.375C16.9961 18 17.5 17.4961 17.5 16.875V10.5H7V16.875ZM14.5 12.2812C14.5 12.1266 14.6266 12 14.7812 12H15.7188C15.8734 12 16 12.1266 16 12.2812V13.2188C16 13.3734 15.8734 13.5 15.7188 13.5H14.7812C14.6266 13.5 14.5 13.3734 14.5 13.2188V12.2812ZM14.5 15.2812C14.5 15.1266 14.6266 15 14.7812 15H15.7188C15.8734 15 16 15.1266 16 15.2812V16.2188C16 16.3734 15.8734 16.5 15.7188 16.5H14.7812C14.6266 16.5 14.5 16.3734 14.5 16.2188V15.2812ZM11.5 12.2812C11.5 12.1266 11.6266 12 11.7812 12H12.7188C12.8734 12 13 12.1266 13 12.2812V13.2188C13 13.3734 12.8734 13.5 12.7188 13.5H11.7812C11.6266 13.5 11.5 13.3734 11.5 13.2188V12.2812ZM11.5 15.2812C11.5 15.1266 11.6266 15 11.7812 15H12.7188C12.8734 15 13 15.1266 13 15.2812V16.2188C13 16.3734 12.8734 16.5 12.7188 16.5H11.7812C11.6266 16.5 11.5 16.3734 11.5 16.2188V15.2812ZM8.5 12.2812C8.5 12.1266 8.62656 12 8.78125 12H9.71875C9.87344 12 10 12.1266 10 12.2812V13.2188C10 13.3734 9.87344 13.5 9.71875 13.5H8.78125C8.62656 13.5 8.5 13.3734 8.5 13.2188V12.2812ZM8.5 15.2812C8.5 15.1266 8.62656 15 8.78125 15H9.71875C9.87344 15 10 15.1266 10 15.2812V16.2188C10 16.3734 9.87344 16.5 9.71875 16.5H8.78125C8.62656 16.5 8.5 16.3734 8.5 16.2188V15.2812ZM16.375 7.5H15.25V6.375C15.25 6.16875 15.0813 6 14.875 6H14.125C13.9187 6 13.75 6.16875 13.75 6.375V7.5H10.75V6.375C10.75 6.16875 10.5812 6 10.375 6H9.625C9.41875 6 9.25 6.16875 9.25 6.375V7.5H8.125C7.50391 7.5 7 8.00391 7 8.625V9.75H17.5V8.625C17.5 8.00391 16.9961 7.5 16.375 7.5Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>
                <div class="assignee-slot" *ngIf="inspection.assignee || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="
                      openAssignmentModal(inspection, 'noDate'); selectedType = 'noDate'; $event.stopPropagation()
                    ">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    *ngIf="!inspection.assignee && this.canAssign"
                    class="tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'noDate'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>

                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Ready to be Assigned -->
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="toBeAssigned !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="
                let inspection of toBeAssigned
                  | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue">!</span>
                    <br *ngIf="inspection.overdue" />
                    {{ inspection.day }} {{ inspection.month }}
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>
              </div>

              <div class="card-footer-actions" *ngIf="canEdit">
                <div class="tooltip-container" data-tooltip="Assign vendor" (click)="assignVendor($event, inspection)">
                  <span class="default-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M12 6C8.68548 6 6 8.68548 6 12C6 15.3145 8.68548 18 12 18C15.3145 18 18 15.3145 18 12C18 8.68548 15.3145 6 12 6ZM12 8.32258C13.1758 8.32258 14.129 9.27581 14.129 10.4516C14.129 11.6274 13.1758 12.5806 12 12.5806C10.8242 12.5806 9.87097 11.6274 9.87097 10.4516C9.87097 9.27581 10.8242 8.32258 12 8.32258ZM12 16.6452C10.5798 16.6452 9.30726 16.0016 8.45565 14.9952C8.91048 14.1387 9.80081 13.5484 10.8387 13.5484C10.8968 13.5484 10.9548 13.5581 11.0105 13.575C11.325 13.6766 11.654 13.7419 12 13.7419C12.346 13.7419 12.6774 13.6766 12.9895 13.575C13.0452 13.5581 13.1032 13.5484 13.1613 13.5484C14.1992 13.5484 15.0895 14.1387 15.5444 14.9952C14.6927 16.0016 13.4202 16.6452 12 16.6452Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <span class="hover-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M12 6C8.68548 6 6 8.68548 6 12C6 15.3145 8.68548 18 12 18C15.3145 18 18 15.3145 18 12C18 8.68548 15.3145 6 12 6ZM12 8.32258C13.1758 8.32258 14.129 9.27581 14.129 10.4516C14.129 11.6274 13.1758 12.5806 12 12.5806C10.8242 12.5806 9.87097 11.6274 9.87097 10.4516C9.87097 9.27581 10.8242 8.32258 12 8.32258ZM12 16.6452C10.5798 16.6452 9.30726 16.0016 8.45565 14.9952C8.91048 14.1387 9.80081 13.5484 10.8387 13.5484C10.8968 13.5484 10.9548 13.5581 11.0105 13.575C11.325 13.6766 11.654 13.7419 12 13.7419C12.346 13.7419 12.6774 13.6766 12.9895 13.575C13.0452 13.5581 13.1032 13.5484 13.1613 13.5484C14.1992 13.5484 15.0895 14.1387 15.5444 14.9952C14.6927 16.0016 13.4202 16.6452 12 16.6452Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>
                <div class="assignee-slot" *ngIf="inspection.assignee || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="openAssignmentModal(inspection, 'toBeAssigned'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    *ngIf="!inspection.assignee && this.canAssign"
                    class="tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'toBeAssigned'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>
                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Assignment Made -->
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="assigned !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="
                let inspection of assigned | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue">!</span>
                    <br *ngIf="inspection.overdue" />
                    {{ inspection.day }} {{ inspection.month }}
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>

                <div style="padding-top: 10px" [style.padding-top]="!inspection.forecasted ? '10px' : '0'">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer-actions">
                <div
                  *ngIf="shouldShowEmailModal(inspection)"
                  class="tooltip-container"
                  data-tooltip="Send email"
                  (click)="showEmailModal(inspection); $event.stopPropagation()">
                  <!-- Default SVG -->
                  <span class="default-svg blue-badge email-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0.5 13 12" fill="none">
                      <path
                        d="M12.0175 3.56813C12.1089 3.49547 12.2449 3.56344 12.2449 3.67828V8.47125C12.2449 9.09235 11.741 9.59625 11.1199 9.59625H1.36987C0.748779 9.59625 0.244873 9.09235 0.244873 8.47125V3.68063C0.244873 3.56344 0.378467 3.49781 0.472217 3.57047C0.997217 3.97828 1.69331 4.49625 4.08394 6.23297C4.57847 6.59391 5.41284 7.35328 6.24487 7.3486C7.08159 7.35563 7.93237 6.57985 8.40815 6.23297C10.7988 4.49625 11.4925 3.97594 12.0175 3.56813ZM6.24487 6.59625C6.78862 6.60563 7.57144 5.91188 7.96519 5.62594C11.0753 3.36891 11.3121 3.17203 12.0292 2.60953C12.1652 2.50406 12.2449 2.34 12.2449 2.16656V1.72125C12.2449 1.10016 11.741 0.596252 11.1199 0.596252H1.36987C0.748779 0.596252 0.244873 1.10016 0.244873 1.72125V2.16656C0.244873 2.34 0.324561 2.50172 0.460498 2.60953C1.17769 3.16969 1.4144 3.36891 4.52456 5.62594C4.91831 5.91188 5.70112 6.60563 6.24487 6.59625Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <!-- Hover SVG -->
                  <span class="hover-svg blue-badge email-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0.5 13 12" fill="none">
                      <path
                        d="M12.0175 3.56813C12.1089 3.49547 12.2449 3.56344 12.2449 3.67828V8.47125C12.2449 9.09235 11.741 9.59625 11.1199 9.59625H1.36987C0.748779 9.59625 0.244873 9.09235 0.244873 8.47125V3.68063C0.244873 3.56344 0.378467 3.49781 0.472217 3.57047C0.997217 3.97828 1.69331 4.49625 4.08394 6.23297C4.57847 6.59391 5.41284 7.35328 6.24487 7.3486C7.08159 7.35563 7.93237 6.57985 8.40815 6.23297C10.7988 4.49625 11.4925 3.97594 12.0175 3.56813ZM6.24487 6.59625C6.78862 6.60563 7.57144 5.91188 7.96519 5.62594C11.0753 3.36891 11.3121 3.17203 12.0292 2.60953C12.1652 2.50406 12.2449 2.34 12.2449 2.16656V1.72125C12.2449 1.10016 11.741 0.596252 11.1199 0.596252H1.36987C0.748779 0.596252 0.244873 1.10016 0.244873 1.72125V2.16656C0.244873 2.34 0.324561 2.50172 0.460498 2.60953C1.17769 3.16969 1.4144 3.36891 4.52456 5.62594C4.91831 5.91188 5.70112 6.60563 6.24487 6.59625Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>
                <div class="assignee-slot" *ngIf="inspection.assignee || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="openAssignmentModal(inspection, 'assigned'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    *ngIf="!inspection.assignee && this.canAssign"
                    class="tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'assigned'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>
                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Due Completion -->
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="dueCompletion !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="
                let inspection of dueCompletion
                  | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              "
              [routerLink]="'/inspection/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue && !inspection.lastSynced">!</span>
                    <span class="error-badge" style="background-color: #ec9006" *ngIf="inspection.lastSynced"
                      ><i class="fa fa-refresh"></i
                    ></span>
                    <br *ngIf="inspection.overdue" />
                    {{ inspection.day }} {{ inspection.month }}
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>

                <div style="padding-top: 10px" [style.padding-top]="!inspection.forecasted ? '10px' : '0'">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card-footer-actions"
                *ngIf="shouldShowEmailModal(inspection) || inspection.assignee || canAssign">
                <div
                  *ngIf="shouldShowEmailModal(inspection)"
                  class="tooltip-container"
                  (click)="showEmailModal(inspection); $event.stopPropagation()"
                  data-tooltip="Send email">
                  <!-- Default SVG -->
                  <span class="default-svg blue-badge email-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0.5 13 12" fill="none">
                      <path
                        d="M12.0175 3.56813C12.1089 3.49547 12.2449 3.56344 12.2449 3.67828V8.47125C12.2449 9.09235 11.741 9.59625 11.1199 9.59625H1.36987C0.748779 9.59625 0.244873 9.09235 0.244873 8.47125V3.68063C0.244873 3.56344 0.378467 3.49781 0.472217 3.57047C0.997217 3.97828 1.69331 4.49625 4.08394 6.23297C4.57847 6.59391 5.41284 7.35328 6.24487 7.3486C7.08159 7.35563 7.93237 6.57985 8.40815 6.23297C10.7988 4.49625 11.4925 3.97594 12.0175 3.56813ZM6.24487 6.59625C6.78862 6.60563 7.57144 5.91188 7.96519 5.62594C11.0753 3.36891 11.3121 3.17203 12.0292 2.60953C12.1652 2.50406 12.2449 2.34 12.2449 2.16656V1.72125C12.2449 1.10016 11.741 0.596252 11.1199 0.596252H1.36987C0.748779 0.596252 0.244873 1.10016 0.244873 1.72125V2.16656C0.244873 2.34 0.324561 2.50172 0.460498 2.60953C1.17769 3.16969 1.4144 3.36891 4.52456 5.62594C4.91831 5.91188 5.70112 6.60563 6.24487 6.59625Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <!-- Hover SVG -->
                  <span class="hover-svg blue-badge email-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0.5 13 12" fill="none">
                      <path
                        d="M12.0175 3.56813C12.1089 3.49547 12.2449 3.56344 12.2449 3.67828V8.47125C12.2449 9.09235 11.741 9.59625 11.1199 9.59625H1.36987C0.748779 9.59625 0.244873 9.09235 0.244873 8.47125V3.68063C0.244873 3.56344 0.378467 3.49781 0.472217 3.57047C0.997217 3.97828 1.69331 4.49625 4.08394 6.23297C4.57847 6.59391 5.41284 7.35328 6.24487 7.3486C7.08159 7.35563 7.93237 6.57985 8.40815 6.23297C10.7988 4.49625 11.4925 3.97594 12.0175 3.56813ZM6.24487 6.59625C6.78862 6.60563 7.57144 5.91188 7.96519 5.62594C11.0753 3.36891 11.3121 3.17203 12.0292 2.60953C12.1652 2.50406 12.2449 2.34 12.2449 2.16656V1.72125C12.2449 1.10016 11.741 0.596252 11.1199 0.596252H1.36987C0.748779 0.596252 0.244873 1.10016 0.244873 1.72125V2.16656C0.244873 2.34 0.324561 2.50172 0.460498 2.60953C1.17769 3.16969 1.4144 3.36891 4.52456 5.62594C4.91831 5.91188 5.70112 6.60563 6.24487 6.59625Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>
                <div class="assignee-slot" *ngIf="inspection.assignee || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="openAssignmentModal(inspection, 'dueCompletion'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    *ngIf="!inspection.assignee && this.canAssign"
                    class="tooltip-container"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'dueCompletion'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>
                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Need Review -->
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="needsReview !== null">
            <div
              class="card-inspection"
              [routerLink]="'/inspection/form/' + inspection.id"
              [ngClass]="getInspectionScoreClass(inspection)"
              *ngFor="
                let inspection of needsReview | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              ">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                    <div class="days" [ngClass]="getDaysClass(inspection)">
                      {{ inspection.daysSince }} day{{ inspection.daysSince > 1 ? 's' : '' }}
                    </div>
                  </div>

                  <div
                    style="text-align: center; font-weight: 500; font-size: 1.1em"
                    class="badge-wrapper"
                    [ngClass]="{ invalid: inspection.invalid || inspection.daysSince > needsReviewHighlightTimeFrame }">
                    <span
                      *ngIf="
                        !inspection.invalid &&
                        inspection.daysSince > needsReviewHighlightTimeFrame &&
                        !(scoresEnabled && inspection.flaggingScore)
                      ">
                      <span class="error-badge">!</span>
                      <br />
                    </span>

                    <span *ngIf="inspection.invalid">
                      <span class="invalid-badge">Invalid</span>
                      <br />
                    </span>

                    <span
                      *ngIf="
                        (!scoresEnabled || !inspection.flaggingScore) &&
                        !inspection.invalid &&
                        inspection.daysSince <= needsReviewHighlightTimeFrame
                      ">
                      <span class="ok-badge"><i class="fa fa-check"></i></span>
                      <br />
                    </span>

                    <span *ngIf="scoresEnabled && inspection.flaggingScore">
                      <span class="score-badge"><i style="font-size: 14px" class="fa fa-warning"></i></span>
                      <br />
                    </span>
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer-actions" *ngIf="canReview" [ngClass]="getInspectionScoreClass(inspection)">
                <div
                  (click)="clearTreeCace(); $event.stopPropagation()"
                  class="tooltip-container"
                  [attr.data-tooltip]="inspection.invalid ? 'Fix' : 'Review'"
                  [routerLink]="
                    inspection.invalid
                      ? '/inspection/review-invalid/' + inspection.id
                      : '/inspection/review/main/' + inspection.id
                  "
                  [queryParams]="!inspection.invalid ? { right: 'question' } : null">
                  <!-- Default SVG Review-->
                  <span class="default-svg has-score-icon-hover" *ngIf="!inspection.invalid">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M9.67344 9.81004C9.67344 8.98292 10.3464 8.31004 11.1734 8.31004H14.8163V6.38147C14.8163 6.02643 14.5285 5.73861 14.1734 5.73861H12.0142C11.7174 5.22674 11.1637 4.88147 10.5306 4.88147C9.89745 4.88147 9.34382 5.22674 9.04693 5.73861H6.88773C6.53269 5.73861 6.24487 6.02643 6.24487 6.38147V15.3815C6.24487 15.7365 6.53269 16.0243 6.88773 16.0243H9.67344V9.81004ZM10.5306 5.9529C10.8856 5.9529 11.1734 6.24071 11.1734 6.59576C11.1734 6.9508 10.8856 7.23861 10.5306 7.23861C10.1755 7.23861 9.88773 6.9508 9.88773 6.59576C9.88773 6.24071 10.1755 5.9529 10.5306 5.9529ZM15.4592 12.5958H18.2449V17.9529C18.2449 18.3079 17.9571 18.5958 17.602 18.5958H11.1734C10.8184 18.5958 10.5306 18.3079 10.5306 17.9529V9.81004C10.5306 9.455 10.8184 9.16718 11.1734 9.16718H14.8163V11.9529C14.8163 12.3065 15.1056 12.5958 15.4592 12.5958ZM18.2449 11.5763V11.7386H15.6734V9.16718H15.8357C16.0062 9.16718 16.1697 9.23491 16.2903 9.35546L18.0566 11.1217C18.1771 11.2423 18.2449 11.4058 18.2449 11.5763Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <!-- Hover SVG Review -->

                  <span class="hover-svg" *ngIf="!inspection.invalid">
                    <svg
                      *ngIf="inspection.flaggingScore"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 33"
                      fill="none">
                      <path
                        d="M31.3333 16.6406C31.3333 25.1306 24.4669 32.0106 16 32.0106C7.53307 32.0106 0.666667 25.1306 0.666667 16.6406C0.666667 8.15059 7.53307 1.27067 16 1.27067C24.4669 1.27067 31.3333 8.15059 31.3333 16.6406Z"
                        stroke="white"
                        stroke-opacity="0.16"
                        stroke-width="1.33333" />
                      <path
                        d="M12.8981 13.7139C12.8981 12.6086 13.7953 11.7093 14.8981 11.7093H19.7552V9.13202C19.7552 8.65754 19.3715 8.27291 18.8981 8.27291H16.0192C15.6233 7.58885 14.8851 7.12744 14.0409 7.12744C13.1968 7.12744 12.4586 7.58885 12.0627 8.27291H9.1838C8.71041 8.27291 8.32666 8.65754 8.32666 9.13202V21.1595C8.32666 21.634 8.71041 22.0186 9.1838 22.0186H12.8981V13.7139ZM14.0409 8.55928C14.5143 8.55928 14.8981 8.94391 14.8981 9.41839C14.8981 9.89286 14.5143 10.2775 14.0409 10.2775C13.5676 10.2775 13.1838 9.89286 13.1838 9.41839C13.1838 8.94391 13.5676 8.55928 14.0409 8.55928ZM20.6124 17.4367H24.3267V24.5959C24.3267 25.0704 23.9429 25.455 23.4695 25.455H14.8981C14.4247 25.455 14.0409 25.0704 14.0409 24.5959V13.7139C14.0409 13.2394 14.4247 12.8548 14.8981 12.8548H19.7552V16.5776C19.7552 17.0501 20.1409 17.4367 20.6124 17.4367ZM24.3267 16.0743V16.2912H20.8981V12.8548H21.1145C21.3418 12.8548 21.5598 12.9453 21.7206 13.1064L24.0756 15.4668C24.2363 15.628 24.3267 15.8465 24.3267 16.0743Z"
                        fill="white" />
                    </svg>

                    <svg
                      *ngIf="!inspection.flaggingScore"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M9.67344 9.81004C9.67344 8.98292 10.3464 8.31004 11.1734 8.31004H14.8163V6.38147C14.8163 6.02643 14.5285 5.73861 14.1734 5.73861H12.0142C11.7174 5.22674 11.1637 4.88147 10.5306 4.88147C9.89745 4.88147 9.34382 5.22674 9.04693 5.73861H6.88773C6.53269 5.73861 6.24487 6.02643 6.24487 6.38147V15.3815C6.24487 15.7365 6.53269 16.0243 6.88773 16.0243H9.67344V9.81004ZM10.5306 5.9529C10.8856 5.9529 11.1734 6.24071 11.1734 6.59576C11.1734 6.9508 10.8856 7.23861 10.5306 7.23861C10.1755 7.23861 9.88773 6.9508 9.88773 6.59576C9.88773 6.24071 10.1755 5.9529 10.5306 5.9529ZM15.4592 12.5958H18.2449V17.9529C18.2449 18.3079 17.9571 18.5958 17.602 18.5958H11.1734C10.8184 18.5958 10.5306 18.3079 10.5306 17.9529V9.81004C10.5306 9.455 10.8184 9.16718 11.1734 9.16718H14.8163V11.9529C14.8163 12.3065 15.1056 12.5958 15.4592 12.5958ZM18.2449 11.5763V11.7386H15.6734V9.16718H15.8357C16.0062 9.16718 16.1697 9.23491 16.2903 9.35546L18.0566 11.1217C18.1771 11.2423 18.2449 11.4058 18.2449 11.5763Z"
                        fill="#2763CD" />
                    </svg>
                  </span>

                  <!-- Fix icon For Invalid inspections -->
                  <span class="default-svg blue-badge has-score-icon-hover" *ngIf="inspection.invalid">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M1.84212 0.117225C1.61946 -0.0562124 1.30306 -0.0351186 1.10149 0.1641L0.163994 1.1016C-0.0352245 1.30082 -0.0563183 1.61723 0.114776 1.84223L1.98978 4.27973C2.09524 4.41801 2.26165 4.50004 2.43509 4.50004H3.70306L6.25774 7.05473C5.91321 7.73441 6.02337 8.58754 6.5929 9.15473L9.2179 11.7797C9.51087 12.0727 9.98665 12.0727 10.2796 11.7797L11.7796 10.2797C12.0726 9.98676 12.0726 9.51097 11.7796 9.21801L9.15462 6.59301C8.58743 6.02582 7.73431 5.91332 7.05462 6.25785L4.49993 3.70316V2.43519C4.49993 2.25941 4.4179 2.09535 4.27962 1.98988L1.84212 0.117225ZM0.466338 9.28363C0.168682 9.58129 -6.82519e-05 9.98676 -6.82519e-05 10.4086C-6.82519e-05 11.2875 0.712432 12 1.59134 12C2.01321 12 2.41868 11.8313 2.71634 11.5336L5.47728 8.77269C5.29446 8.28285 5.26634 7.75082 5.3929 7.24691L3.94681 5.80082L0.466338 9.28363ZM11.9999 3.37504C11.9999 3.12894 11.9742 2.88988 11.9249 2.66019C11.8687 2.39769 11.5476 2.32973 11.3577 2.51957L9.86009 4.01723C9.78978 4.08754 9.69368 4.12738 9.59524 4.12738L8.24993 4.12504C8.04368 4.12504 7.87493 3.95629 7.87493 3.75004V2.40473C7.87493 2.30629 7.91478 2.21019 7.98509 2.13988L9.48274 0.642225C9.67259 0.452381 9.60462 0.131288 9.34212 0.0750376C9.11009 0.0258189 8.87103 3.76048e-05 8.62493 3.76048e-05C6.76165 3.76048e-05 5.24993 1.51176 5.24993 3.37504V3.39379L7.24915 5.39301C8.0929 5.17973 9.02571 5.40473 9.68665 6.06566L10.0546 6.43363C11.2031 5.89457 11.9999 4.72738 11.9999 3.37504ZM1.31243 10.125C1.31243 9.97585 1.3717 9.83278 1.47718 9.72729C1.58267 9.6218 1.72575 9.56254 1.87493 9.56254C2.02412 9.56254 2.16719 9.6218 2.27268 9.72729C2.37817 9.83278 2.43743 9.97585 2.43743 10.125C2.43743 10.2742 2.37817 10.4173 2.27268 10.5228C2.16719 10.6283 2.02412 10.6875 1.87493 10.6875C1.72575 10.6875 1.58267 10.6283 1.47718 10.5228C1.3717 10.4173 1.31243 10.2742 1.31243 10.125Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <span class="hover-svg blue-badge" *ngIf="inspection.invalid">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M2.45665 0.156137C2.15977 -0.0751126 1.7379 -0.0469876 1.46915 0.218637L0.219147 1.46864C-0.0464777 1.73426 -0.0746027 2.15614 0.153522 2.45614L2.65352 5.70614C2.79415 5.89051 3.01602 5.99989 3.24727 5.99989H4.9379L8.34415 9.40614C7.88477 10.3124 8.03165 11.4499 8.79102 12.2061L12.291 15.7061C12.6816 16.0968 13.316 16.0968 13.7066 15.7061L15.7066 13.7061C16.0973 13.3155 16.0973 12.6811 15.7066 12.2905L12.2066 8.79051C11.4504 8.03426 10.3129 7.88426 9.40665 8.34364L6.0004 4.93739V3.24676C6.0004 3.01239 5.89102 2.79364 5.70665 2.65301L2.45665 0.156137ZM0.622272 12.378C0.225397 12.7749 0.000397279 13.3155 0.000397279 13.878C0.000397279 15.0499 0.950397 15.9999 2.12227 15.9999C2.68477 15.9999 3.2254 15.7749 3.62227 15.378L7.30352 11.6968C7.05977 11.0436 7.02227 10.3343 7.19102 9.66239L5.2629 7.73426L0.622272 12.378ZM16.0004 4.49989C16.0004 4.17176 15.966 3.85301 15.9004 3.54676C15.8254 3.19676 15.3973 3.10614 15.1441 3.35926L13.1473 5.35614C13.0535 5.44989 12.9254 5.50301 12.7941 5.50301L11.0004 5.49989C10.7254 5.49989 10.5004 5.27489 10.5004 4.99989V3.20614C10.5004 3.07489 10.5535 2.94676 10.6473 2.85301L12.6441 0.856137C12.8973 0.603012 12.8066 0.174887 12.4566 0.0998874C12.1473 0.0342624 11.8285 -0.000112621 11.5004 -0.000112621C9.01602 -0.000112621 7.0004 2.01551 7.0004 4.49989V4.52489L9.66602 7.19051C10.791 6.90614 12.0348 7.20614 12.916 8.08739L13.4066 8.57801C14.9379 7.85926 16.0004 6.30301 16.0004 4.49989ZM1.7504 13.4999C1.7504 13.301 1.82941 13.1102 1.97007 12.9696C2.11072 12.8289 2.30148 12.7499 2.5004 12.7499C2.69931 12.7499 2.89008 12.8289 3.03073 12.9696C3.17138 13.1102 3.2504 13.301 3.2504 13.4999C3.2504 13.6988 3.17138 13.8896 3.03073 14.0302C2.89008 14.1709 2.69931 14.2499 2.5004 14.2499C2.30148 14.2499 2.11072 14.1709 1.97007 14.0302C1.82941 13.8896 1.7504 13.6988 1.7504 13.4999Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>

                <div class="assignee-slot" *ngIf="inspection.assignee || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assignee"
                    (click)="openAssignmentModal(inspection, 'needsReview'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    class="tooltip-container"
                    *ngIf="!inspection.assignee && this.canAssign"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'needsReview'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>
                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Under Review -->
      <div class="column">
        <div class="scrollable" forScroll>
          <ng-container *ngIf="underReview !== null">
            <div
              class="card-inspection"
              [routerLink]="'/inspection/form/' + inspection.id"
              [ngClass]="getInspectionScoreClass(inspection)"
              *ngFor="
                let inspection of underReview | searchPipe: { searchTerm: this.search, productTypes, filteredAssignees }
              ">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                    <div class="days" [ngClass]="getDaysClass(inspection)">
                      {{ inspection.daysSince }} day{{ inspection.daysSince > 1 ? 's' : '' }}
                    </div>
                  </div>

                  <div
                    style="text-align: center; font-weight: 500; font-size: 1.1em"
                    class="badge-wrapper"
                    [ngClass]="{ invalid: inspection.invalid || inspection.daysSince > needsReviewHighlightTimeFrame }">
                    <span
                      *ngIf="
                        !inspection.invalid &&
                        inspection.daysSince > needsReviewHighlightTimeFrame &&
                        !(scoresEnabled && inspection.flaggingScore)
                      ">
                      <span class="error-badge">!</span>
                      <br />
                    </span>

                    <span *ngIf="inspection.invalid">
                      <span class="invalid-badge">Invalid</span>
                      <br />
                    </span>

                    <span
                      *ngIf="
                        (!scoresEnabled || !inspection.flaggingScore) &&
                        !inspection.invalid &&
                        inspection.daysSince <= needsReviewHighlightTimeFrame
                      ">
                      <span class="ok-badge"><i class="fa fa-check"></i></span>
                      <br />
                    </span>

                    <span *ngIf="scoresEnabled && inspection.flaggingScore">
                      <span class="score-badge"><i style="font-size: 14px" class="fa fa-warning"></i></span>
                      <br />
                    </span>
                    <div *ngIf="scoresEnabled && inspection.flaggingScore" class="score">
                      {{ inspection.flaggingScore }}
                    </div>
                  </div>
                </div>

                <div style="margin-top: 10px">
                  <div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="card-footer-actions"
                *ngIf="!inspection.invalid && canReview"
                [ngClass]="getInspectionScoreClass(inspection)">
                <div
                  class="tooltip-container"
                  data-tooltip="Review"
                  (click)="clearTreeCace(); $event.stopPropagation()"
                  [routerLink]="
                    inspection.invalid && canReview
                      ? '/inspection/review-invalid/' + inspection.id
                      : '/inspection/review/main/' + inspection.id
                  "
                  [queryParams]="!inspection.invalid ? { right: 'question' } : null">
                  <!-- Default SVG -->
                  <span class="default-svg has-score-icon-hover">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M9.67344 9.81004C9.67344 8.98292 10.3464 8.31004 11.1734 8.31004H14.8163V6.38147C14.8163 6.02643 14.5285 5.73861 14.1734 5.73861H12.0142C11.7174 5.22674 11.1637 4.88147 10.5306 4.88147C9.89745 4.88147 9.34382 5.22674 9.04693 5.73861H6.88773C6.53269 5.73861 6.24487 6.02643 6.24487 6.38147V15.3815C6.24487 15.7365 6.53269 16.0243 6.88773 16.0243H9.67344V9.81004ZM10.5306 5.9529C10.8856 5.9529 11.1734 6.24071 11.1734 6.59576C11.1734 6.9508 10.8856 7.23861 10.5306 7.23861C10.1755 7.23861 9.88773 6.9508 9.88773 6.59576C9.88773 6.24071 10.1755 5.9529 10.5306 5.9529ZM15.4592 12.5958H18.2449V17.9529C18.2449 18.3079 17.9571 18.5958 17.602 18.5958H11.1734C10.8184 18.5958 10.5306 18.3079 10.5306 17.9529V9.81004C10.5306 9.455 10.8184 9.16718 11.1734 9.16718H14.8163V11.9529C14.8163 12.3065 15.1056 12.5958 15.4592 12.5958ZM18.2449 11.5763V11.7386H15.6734V9.16718H15.8357C16.0062 9.16718 16.1697 9.23491 16.2903 9.35546L18.0566 11.1217C18.1771 11.2423 18.2449 11.4058 18.2449 11.5763Z"
                        fill="#7B8EAD" />
                    </svg>
                  </span>

                  <!-- Hover SVG -->
                  <span class="hover-svg">
                    <svg
                      *ngIf="inspection.flaggingScore"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 33"
                      fill="none">
                      <path
                        d="M31.3333 16.6406C31.3333 25.1306 24.4669 32.0106 16 32.0106C7.53307 32.0106 0.666667 25.1306 0.666667 16.6406C0.666667 8.15059 7.53307 1.27067 16 1.27067C24.4669 1.27067 31.3333 8.15059 31.3333 16.6406Z"
                        stroke="white"
                        stroke-opacity="0.16"
                        stroke-width="1.33333" />
                      <path
                        d="M12.8981 13.7139C12.8981 12.6086 13.7953 11.7093 14.8981 11.7093H19.7552V9.13202C19.7552 8.65754 19.3715 8.27291 18.8981 8.27291H16.0192C15.6233 7.58885 14.8851 7.12744 14.0409 7.12744C13.1968 7.12744 12.4586 7.58885 12.0627 8.27291H9.1838C8.71041 8.27291 8.32666 8.65754 8.32666 9.13202V21.1595C8.32666 21.634 8.71041 22.0186 9.1838 22.0186H12.8981V13.7139ZM14.0409 8.55928C14.5143 8.55928 14.8981 8.94391 14.8981 9.41839C14.8981 9.89286 14.5143 10.2775 14.0409 10.2775C13.5676 10.2775 13.1838 9.89286 13.1838 9.41839C13.1838 8.94391 13.5676 8.55928 14.0409 8.55928ZM20.6124 17.4367H24.3267V24.5959C24.3267 25.0704 23.9429 25.455 23.4695 25.455H14.8981C14.4247 25.455 14.0409 25.0704 14.0409 24.5959V13.7139C14.0409 13.2394 14.4247 12.8548 14.8981 12.8548H19.7552V16.5776C19.7552 17.0501 20.1409 17.4367 20.6124 17.4367ZM24.3267 16.0743V16.2912H20.8981V12.8548H21.1145C21.3418 12.8548 21.5598 12.9453 21.7206 13.1064L24.0756 15.4668C24.2363 15.628 24.3267 15.8465 24.3267 16.0743Z"
                        fill="white" />
                    </svg>

                    <svg
                      *ngIf="!inspection.flaggingScore"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none">
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <circle cx="12" cy="12" r="11.5" stroke="#2763CD" stroke-opacity="0.16" />
                      <path
                        d="M9.67344 9.81004C9.67344 8.98292 10.3464 8.31004 11.1734 8.31004H14.8163V6.38147C14.8163 6.02643 14.5285 5.73861 14.1734 5.73861H12.0142C11.7174 5.22674 11.1637 4.88147 10.5306 4.88147C9.89745 4.88147 9.34382 5.22674 9.04693 5.73861H6.88773C6.53269 5.73861 6.24487 6.02643 6.24487 6.38147V15.3815C6.24487 15.7365 6.53269 16.0243 6.88773 16.0243H9.67344V9.81004ZM10.5306 5.9529C10.8856 5.9529 11.1734 6.24071 11.1734 6.59576C11.1734 6.9508 10.8856 7.23861 10.5306 7.23861C10.1755 7.23861 9.88773 6.9508 9.88773 6.59576C9.88773 6.24071 10.1755 5.9529 10.5306 5.9529ZM15.4592 12.5958H18.2449V17.9529C18.2449 18.3079 17.9571 18.5958 17.602 18.5958H11.1734C10.8184 18.5958 10.5306 18.3079 10.5306 17.9529V9.81004C10.5306 9.455 10.8184 9.16718 11.1734 9.16718H14.8163V11.9529C14.8163 12.3065 15.1056 12.5958 15.4592 12.5958ZM18.2449 11.5763V11.7386H15.6734V9.16718H15.8357C16.0062 9.16718 16.1697 9.23491 16.2903 9.35546L18.0566 11.1217C18.1771 11.2423 18.2449 11.4058 18.2449 11.5763Z"
                        fill="#2763CD" />
                    </svg>
                  </span>
                </div>

                <div class="assignee-slot" *ngIf="inspection.assigneeId || canAssign">
                  <div
                    class="avatar"
                    *ngIf="inspection.assigneeId"
                    (click)="openAssignmentModal(inspection, 'underReview'); $event.stopPropagation()">
                    {{ getInitials(inspection.assignee.name) }}
                  </div>
                  <div
                    class="tooltip-container"
                    *ngIf="!inspection.assignee && this.canAssign"
                    data-tooltip="Assign admin"
                    (click)="openAssignmentModal(inspection, 'underReview'); $event.stopPropagation()">
                    <div class="default-svg">
                      <img src="assets/img/non-assign.svg" alt="" />
                    </div>
                    <div class="hover-svg">
                      <img *ngIf="inspection.flaggingScore" src="assets/img/non-assign-onhover.svg" alt="" />
                      <img *ngIf="!inspection.flaggingScore" src="assets/img/non-assign.svg" alt="" />
                    </div>
                  </div>
                </div>
                <span class="footer-policy"
                  ><span class="footer-policy-text">#{{ inspection.policyNumber }}</span></span
                >
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noResult>
    <div *ngIf="!loading" id="search-wrapper" class="no-result">
      <h2>No search results.</h2>
      <button class="btn btn-danger" (click)="reset()">Reset All</button>
    </div>
    <div *ngIf="loading" id="search-wrapper" class="no-result">
      <div class="spinner-wrapper">
        <span class="spinner"></span>
      </div>
    </div>
  </ng-template>

  <app-assign-vendor-inspection #assignVendorModal></app-assign-vendor-inspection>
  <app-add-date-inspection #addDateModal></app-add-date-inspection>
  <app-send-email-inspection #sendEmailModal></app-send-email-inspection>
  <app-admin-assignment #assignmentModal (onConfirm)="handleConfirm($event)"></app-admin-assignment>
</div>
